window.addEventListener("load", function(e) {
	// setTimeout(function(){$('.modalFW[data-name="modal-confirm"]').modalFW('get').open(); },2000)
});

if (document.body.classList.contains('page--counter')) {
	var ready = false;
	global.handleTickUpdate = function(tick){
		var nbChildren = parseInt($('.counter--content__nbChildren').text());
		if (tick.value >= 12000) {
			$('.counter--content__text--1').removeClass('hidden');
			// console.log(Math.floor(tick.value/12000), nbChildren);
			if (Math.floor(tick.value/12000) > 1)
				$('.counter--content__text--1 .plural').removeClass('hidden');
			else
				$('.counter--content__text--1 .plural').addClass('hidden');
			if (Math.floor(tick.value/12000) != nbChildren && ready){
				
				if (Math.floor(tick.value/12000) > nbChildren) {
					var modalCoeur = $('.modalFW[data-name="modal-coeur"]').modalFW('get');
					var modalConfirm = $('.modalFW[data-name="modal-confirm"]').modalFW('get');
					modalCoeur.open();
					setTimeout(function(){
						// modalCoeur.close()
						modalConfirm.open();
						setTimeout(function(){
							modalConfirm.close();
						},15000)
					},3500)
				}
			}
		} else
			$('.counter--content__text--1').addClass('hidden');

		$('.counter--content__nbChildren').text(Math.floor(tick.value/12000));
		ready = true;
	}

	// global.handleTickInit = function(tick) {
	//     // setInterval(function(){
	//     // 	// requestAmount();
	//     //     tick.value += 12000;
	//     // }, 20000);
	//     setTimeout(function(){
	// 	    tick.value = 12000
	//     },4000)
	// }
}


// WEBPACK FOOTER //
// ./src/themes/initiativecoeur/initiativecoeur.js